import DataGrid from 'src/components/generic/GenericOperatableStoreDataGrid';
import { ChartType, ChartInput } from 'src/services/graphql/Models';
import Chart from 'src/stores/application/classes/Chart';

export class RenderableDataGrid extends DataGrid< ChartInput, Chart > {}
export type ChartInterface = ChartInput;
export const chartTypeOptions = [
  {
      key: ChartType.table,
      value: ChartType.table,
      text: 'Table'
  },
  {
      key: ChartType.line,
      value: ChartType.line,
      text: 'Line'
  },
  {
      key: ChartType.bar,
      value: ChartType.bar,
      text: 'Bar'
  },
  {
      key: ChartType.scatter,
      value: ChartType.scatter,
      text: 'Scatter'
  },
  {
      key: ChartType.pie,
      value: ChartType.pie,
      text: 'Pie'
  },
  {
      key: ChartType.donut,
      value: ChartType.donut,
      text: 'Donut'
  },
  {
      key: ChartType.radar,
      value: ChartType.radar,
      text: 'Radar'
  },
  {
      key: ChartType.polar,
      value: ChartType.polar,
      text: 'Polar'
  }
];



// WEBPACK FOOTER //
// ./src/container/Chart/shared.ts